export default __webpack_public_path__ + "static/media/011-fried chicken.33966255.svg";